/* 曹操傳・第 10 章：赤壁・疫病與華容道（建安十三年，208）
 * 史實：《武帝紀》「公至赤壁，與備戰，不利。於是大疫，吏士多死者，乃引軍還。」
 *       《吳主傳》「公燒其餘船引退，士卒飢疫，死者大半。」
 *       《武帝紀》注引《山陽公載記》：「公船艦爲備所燒，引軍從華容道步歸，遇泥濘，道不通，天又大風，悉使羸兵負草填之，騎乃得過。
 *       羸兵爲人馬所蹈藉，陷泥中，死者甚衆。」
 * 流程：曹軍那一邊的赤壁（和孫吳傳第 12～14 章同一張圖）。1. 疫病在烏林營中蔓延：站在病兵旁邊把他隔離出去，別讓疫病傳開。
 *       2. 黃蓋的火船燒進船陣，火往岸上燒；把西邊還沒燒到的餘船自己燒掉，然後撤退。
 *       3. 華容道泥濘難行：在泥濘處站著讓羸兵負草填路（每一處都要犧牲一個人），追兵從後面趕來。走出華容道即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, TROOPS, troop } from '../kit.ts';
import { SHORE_N, CHAIN_Y, CHAIN } from '../maps/chibi.ts';

const LV = 13, HQ = [4600, 900], PLAGUE_T = 40, EXIT = [1500, 420];
const SHIPS = [[1000, 1640], [1250, 1660], [1500, 1640]], MUD = [[3700, 620], [2900, 640], [2200, 560]];
const CHASER = { spec: troop('sunliu', '孫劉聯軍', { armor: '#8a3a2a', sleeve: '#6a2a20', cloth: '#6a2a20', plume: '#d05a3a' }), name: '孫劉聯軍', hp: 460, maxHp: 460, atk: 26, ms: 230 };
const fake = (x, y) => ({ x, y, f: 1, alive: true, input: {}, fake: true });

export default {
  id: 'caocao-10', map: 'chibi', hero: 'caocao',
  title: '第 10 章　赤壁・疫病與華容道', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '公至赤壁，與備戰，不利。於是大疫，吏士多死者，乃引軍還。', src: '《三國志·魏書·武帝紀》' }],
    text: '曹操取荊州，順江東下，在赤壁與孫劉聯軍相持。北方士卒不習水土，軍中疫病流行。',
    goals: ['隔離病兵，別讓疫病在營中傳開', '燒掉剩下的船，撤退', '負草填路，走出華容道'],
  },
  words: { ally: '曹軍', foe: '孫劉聯軍' },
  fuel(m, x, y) { return (Math.abs(y - CHAIN_Y) < 160 && x > CHAIN[0] - 60 && x < CHAIN[1] + 60) || (y < SHORE_N + 60 && y > 1100 && !SG.MAP.waterAt(x, y) && SG.MAP.walkable(x, y, 0)); },
  spreadMul(m, x, y) { return Math.abs(y - CHAIN_Y) < 160 ? 4 : 0.6; },
  stars: [
    { text: '疫病沒擴散：營中一半以上的兵沒染病', ok: (m) => m.vars.healthy >= m.vars.camp.length / 2 },
    { text: '三艘餘船都親手燒掉', ok: (m) => m.vars.shipsBurnt === 3 },
    { text: '帶 3 人以上走出華容道', ok: (m) => m.vars.out >= 3 },
  ],
  steps: [
    { // 1. 大疫
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = HQ[0]; me.y = HQ[1];
        V.t0 = w.t; V.quarantined = 0;
        V.camp = Array.from({ length: 16 }, (_, i) => { const a = (i / 16) * Math.PI * 2, u = m.recruit(HQ[0] + Math.cos(a) * (250 + (i % 2) * 180), HQ[1] + 150 + Math.sin(a) * (160 + (i % 2) * 100), '曹軍'); u.spec = TROOPS.wei; return u; });
        for (const i of [2, 7, 12]) sicken(w, V.camp[i]);
        V.infT = 5;
        m.line('曹操', '軍中怎麼病倒了這麼多人……把病兵隔開！');
        m.after(4, () => m.line('提示', '站在病兵（身上有「疫」）旁邊不動，就能把他隔離出營。疫病每隔幾秒會傳給身邊的人。'));
        m.obj('plague', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.infT -= dt;
        if (V.infT <= 0) {
          V.infT = 5;
          for (const s of V.camp.filter((u) => u.alive && u.sick && !u.out)) {
            const n = V.camp.filter((u) => u.alive && !u.sick && !u.out && SG.gd(u.x, u.y, s.x, s.y) < 260).sort((a, b) => SG.gd(a.x, a.y, s.x, s.y) - SG.gd(b.x, b.y, s.x, s.y))[0];
            if (n) sicken(w, n);
          }
        }
        for (const u of V.camp) if (u.alive && u.sick && !u.out) m.chanAt(me, 'q' + u.id, u.x, u.y, 110, 1.2, '隔離', () => { u.out = true; V.quarantined++; const p = SG.MAP.nearestFree(6800, 600); u.x = p[0] + (SG.rand() - 0.5) * 200; u.y = p[1]; u.home = [u.x, u.y]; });
        const sick = V.camp.filter((u) => u.alive && u.sick && !u.out).length;
        V.healthy = V.camp.filter((u) => u.alive && !u.sick).length;
        m.get('plague').text = `營中病兵 ${sick} 人，健康的 ${V.healthy} 人（${Math.max(0, Math.ceil(PLAGUE_T - (w.t - V.t0)))} 秒後……）`;
        return w.t - V.t0 >= PLAGUE_T;
      },
    },
    { // 2. 火船來了：燒其餘船，引退
      enter(m, w) {
        const V = m.vars;
        m.done('plague');
        m.wind = [-0.25, -0.97];
        m.line('哨兵', '江上有船來了，插著牙旗……是黃蓋來降了！');
        m.after(3, () => {
          m.big('火船！');
          m.card('公船艦爲備所燒。', '《山陽公載記》（裴注）');
          for (let x = CHAIN[0] + 300; x <= CHAIN[1]; x += 240) m.fire(x, CHAIN_Y, { dps: 70 });
        });
        V.ships = SHIPS.map(([x, y]) => m.boat(fake(x, y), { x, y, big: true, flag: '#3b5a99', col: '#4a3a28' }));
        V.shipsBurnt = 0;
        SHIPS.forEach(([x, y], k) => m.mark('s' + k, x, y - 200, '餘船', true));
        m.after(5, () => m.line('曹操', '船保不住了。西邊那幾艘別留給周瑜——燒了，撤！'));
        m.obj('ships', '燒掉西邊的餘船', 3);
        V.camp.forEach((u) => { if (u.alive && !u.sick) m.join(u, w.player); });
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.ships.forEach((b, k) => {
          if (b.burning) return;
          m.chanAt(me, 's' + k, b.x, SHORE_N - 30, 200, 1.5, '燒船', () => { b.burning = true; V.shipsBurnt++; m.unmark('s' + k); }, { hurt: false });
        });
        m.prog('ships', V.shipsBurnt);
        return V.shipsBurnt >= 3 || m.t > 60;
      },
    },
    { // 3. 華容道
      enter(m, w) {
        const V = m.vars;
        m.done('ships');
        m.card('公燒其餘船引退，士卒飢疫，死者大半。', '《吳主傳》');
        for (const [x, y] of MUD) for (let dx = -2; dx <= 2; dx++) for (let dy = -2; dy <= 2; dy++) m.fire(x + dx * 80, y + dy * 80, { water: true, mud: true, life: 1e9 });
        MUD.forEach(([x, y], k) => m.mark('m' + k, x, y, '泥濘', true));
        m.mark('exit', EXIT[0], EXIT[1], '華容道');
        m.obj('road', '負草填路，走出華容道');
        m.after(3, () => m.line('提示', '泥濘裡走不動。站在泥濘旁讓羸兵負草填路（每一處要犧牲一個人）；追兵就快到了。'));
        V.chase = []; V.chaseT = 6;
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        V.chaseT -= dt;
        if (V.chaseT <= 0) { V.chaseT = 12; for (let i = 0; i < 4; i++) { const p = SG.MAP.nearestFree(6200 + i * 60, 900); const u = m.foe('huangjin', p[0], p[1], CHASER); V.chase.push(u); } }
        for (const u of V.chase) if (u.alive && !(u.target && u.target.alive)) u.home = [me.x, me.y];
        MUD.forEach(([x, y], k) => {
          if (V['fill' + k]) return;
          m.chanAt(me, 'm' + k, x + 260, y, 200, 2, '負草填路', () => {
            V['fill' + k] = true; m.unmark('m' + k);
            for (const [key, c] of m.fires) if (c.mud && SG.gd(c.x, c.y, x, y) < 260) m.fires.delete(key);
            const r = m.alive(V.camp).filter((u) => !u.out && u.owner).sort((a, b) => SG.gd(a.x, a.y, x, y) - SG.gd(b.x, b.y, x, y))[0];
            if (r) { r.alive = false; r.deadT = w.t; w.fx({ k: 'puff', x, y }); }
            if (k === 0) m.card('悉使羸兵負草填之，騎乃得過。羸兵爲人馬所蹈藉，陷泥中，死者甚衆。', '《山陽公載記》（裴注）');
          }, { hurt: false });
        });
        if (!m.near(me, EXIT[0], EXIT[1], 300)) return false;
        V.out = m.alive(V.camp).filter((u) => !u.out && u.owner && SG.gd(u.x, u.y, me.x, me.y) < 800).length;
        return true;
      },
    },
    { // 4. 引軍還
      enter(m) {
        m.done('road'); m.unmark('exit');
        m.line('曹操', '……周瑜、劉備，這筆帳以後再算。');
        m.after(5, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('曹操陣亡'); },
};

// 染疫：慢慢掉血、走不快
function sicken(w, u) {
  if (u.sick) return;
  u.sick = true;
  w.addBuff(u, { id: '疫', t: 9999, neg: true, ms: -0.3, atkP: -0.4 });
}
